import { render, staticRenderFns } from "./NotaryMap.vue?vue&type=template&id=72aa4aba&"
import script from "./NotaryMap.vue?vue&type=script&lang=ts&"
export * from "./NotaryMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports